export default __webpack_public_path__ + "static/national-yards-mobile-09b60fa5c3378b16432a4ff50ec933d9.svg";